import React from 'react';
import { motion } from 'framer-motion';
export function BouncingSign() {
  return <motion.div className="fixed z-50 pointer-events-none" animate={{
    left: ['5%', 'calc(95% - 140px)', 'calc(95% - 140px)', '5%', '5%'],
    top: ['5%', '5%', 'calc(95% - 50px)', 'calc(95% - 50px)', '5%']
  }} transition={{
    duration: 12,
    ease: 'easeInOut',
    times: [0, 0.25, 0.5, 0.75, 1],
    repeat: Infinity
  }} data-id="element-17">
      <div className="bg-red-600 text-white font-bold tracking-widest px-6 py-3 rounded-sm border border-red-400 box-glow-red flex items-center justify-center whitespace-nowrap" data-id="element-18">
        FOR SALE
      </div>
    </motion.div>;
}